import { FilterConfig } from './common';

export type FilterTarget = {
  category: string;
  field?: string;
};

export const getFilterTargetForColumn = (
  columnId: string,
  filterConfig: FilterConfig
): FilterTarget | null => {
  for (const entry of filterConfig) {
    if (entry.type === 'separator' || entry.type === 'quick_filters') {
      continue;
    }

    if (entry.id === columnId) {
      return { category: entry.id };
    }

    if (entry.type === 'category') {
      const matched = entry.fields.find((field) => {
        return field.type !== 'separator' && field.id === columnId;
      });
      if (matched) {
        return { category: entry.id, field: columnId };
      }
    }
  }

  return null;
};
